export const publicUrls = {
  queryAllTeacherInfo: '/feather/teacher/getAll',
};
